import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, Typography } from '@mui/material';

const markdown = `
| Descuento | Indicador Evaluado | Fórmula / Condición Básica |
|-----------|--------------------|-----------------------------|
| \`Dd\`      | Disponibilidad | % minutos no disponibles en ventana horaria. |
| \`Dl\`      | Latencia (> 100 ms) | (minutos con latencia > 100 ms / total minutos válidos) × 0.5 |
| \`Dp\`      | Pérdida de paquetes (> 1%) | (minutos con pérdida > 1% / total minutos válidos) × 0.5 |
| \`Dtb\`     | Ancho de Banda Bajada | ((Comprometido - max(promedio mensual, valor máximo)) / Comprometido) × 100 |
| \`Dts\`     | Ancho de Banda Subida (mín. 25% de bajada) | ((Comprometido - max(promedio mensual, valor máximo)) / Comprometido) × 100 |
| \`Di\`      | Ancho de Banda Internacional | ((Comprometido - medido) / Comprometido) × 100 |
| \`Dr\`      | Tiempo de respuesta a incidentes | Se penaliza si no se responde dentro del tiempo establecido por tabla de SLA |
| \`Db\`      | Tiempo de restablecimiento del servicio | Se penaliza si se excede el tiempo máximo de recuperación definido |
| \`Ds\`      | Tiempo de resolución del incidente | Se penaliza si se supera el tiempo límite para cerrar el incidente |
`;

const tableStyles = {
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '1rem',
  },
  th: {
    border: '1px solid #ccc',
    padding: '8px',
    backgroundColor: '#f2f2f2',
    textAlign: 'left',
  },
  td: {
    border: '1px solid #ccc',
    padding: '8px',
    textAlign: 'left',
    verticalAlign: 'top',
  },
};

export default function TablaDescuentosMarkdown() {
  return (
    <div style={{ padding: '1rem', textAlign: 'center' }}>
      <hr style={{ marginBottom: '2rem', borderTop: '1px solid #ccc' }} /> 
      <h2>Glosario de Descuentos</h2>
      <p>En este recuadro se presenta el detalle de los descuentos aplicados por RBD en caso de desviaciones respecto a los parámetros acordados.</p>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          table: ({ children }) => <table style={tableStyles.table}>{children}</table>,
          th: ({ children }) => <th style={tableStyles.th}>{children}</th>,
          td: ({ children }) => <td style={tableStyles.td}>{children}</td>,
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}

